import React, { useState } from "react";
import { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import axios from "axios";
import "./styles/hero.css";
import parse from "html-react-parser";
import Footer from "../components/Footer";
import videoDetailBg from "../Assets/images/Hero_Skill_Detail_Bg.png";
import abilitiesBgHighRes from "../Assets/images/changelog-bg.png";
import abilitiesBgLowRes from "../Assets/images/changelog-bg-low.png";
import OptimizedDiv from "../components/OptimizedDiv";
import skillBorder from "../Assets/images/Hero_Skill_Frame.png";
import skillBorderActive from "../Assets/images/Hero_Skill_Hover_Select.png";
import viewAllBtn from "../Assets/images/Btn_Viewall_Normal.png";
import viewAllBtnActive from "../Assets/images/Btn_Viewall_Hover.png";
import heroAvatarFrame from "../Assets/images/Hero_Thumb_frame02.png";
import heroAvatarFrame2 from "../Assets/images/Hero_Thumb_frame.png";
import prevBg from "../Assets/images/Hero_Previous_Hero_Bg.png";
import nextBg from "../Assets/images/Hero_Next_Hero_Bg.png";
import heroAttributeBg from "../Assets/images/Hero_Attribute_bg.png";
import heroAttributeBar from "../Assets/images/Hero_Attribute_Bg_Bar.png";
import heroStatBg from "../Assets/images/Hero_Stat_Bg.png";
import statIcon1 from "../Assets/images/Icon_HP.png";
import statIcon2 from "../Assets/images/Icon_Mana.png";
import statIcon3 from "../Assets/images/Icon_Damage.png";
import statIcon4 from "../Assets/images/Icon_Attack.png";
import statIcon5 from "../Assets/images/Icon_Defense.png";
import statIcon6 from "../Assets/images/Icon_Mobility.png";
import strength from "../Assets/images/Icon_Strength.png";
import intelligence from "../Assets/images/Icon_Intelligence.png";
import agility from "../Assets/images/Icon_Agility.png";
import spirit from "../Assets/images/Icon_Spirit.png";
import barBg from "../Assets/images/Hero_Role_Pregressbar_Bg.png";
import bar from "../Assets/images/Hero_Role_Pregressbar.png";

const Hero = () => {
  const { name } = useParams();
  const [heroDetails, setHeroDetails] = useState(null);
  const [selectedAbilityIndex, setSelectedAbilityIndex] = useState("");
  const [videoVisible, setVideoVisible] = useState(false);
  const [prevHeroData, setPrevHeroData] = useState(null);
  const [nextHeroData, setNextHeroData] = useState(null);
  const [descExpanded, setDescExpanded] = useState(false);

  function formatDescription(description) {
    if (description) {
      let formattedDescription = description?.replace(
        /<#([a-fA-F0-9]{6})>/g,
        '<span style="color: #$1;">'
      );
      formattedDescription = formattedDescription.replace(
        /<\/color>/g,
        "</span>"
      );

      formattedDescription = formattedDescription.replace(/<u>/g, "<u>");
      formattedDescription = formattedDescription.replace(/<\/u>/g, "</u>");

      formattedDescription = formattedDescription.replace(
        /<link=\"{{[^}]*}}\">/g,
        ""
      );
      formattedDescription = formattedDescription.replace(/<\/link>/g, "");
      return formattedDescription;
    }
  }
  useEffect(() => {
    window.scrollTo(0, 0);
    try {
      axios
        .get(
          `https://cotp-game.azurewebsites.net/api/HeroData/GetSpecificHeroByEnum?heroEnum=${name}`
        )
        .then((res) => {
          setHeroDetails(res.data.requestedHero);
          setPrevHeroData(res.data.previousHero);
          setNextHeroData(res.data.nextHero);
        });
    } catch (e) {
      console.log("error", e);
    }
  }, []);
  useEffect(() => {
    setSelectedAbilityIndex(heroDetails?.abilityData[1]?.abilityClassName);
  }, [heroDetails]);
  return (
    <>
      {!heroDetails ? (
        <div
          style={{
            background: "#000",
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        <>
          <OptimizedDiv
            className={"hero_container"}
            highResImageSrc={abilitiesBgHighRes}
            lowResImageSrc={abilitiesBgLowRes}
            gradient={false}
          >
            <div className="hero_preview_video">
              <video autoPlay muted loop id="myVideo">
                <source src={heroDetails?.heroPreviewVideo} type="video/webm" />
              </video>
            </div>
            <div className="hero_ability">
              <div className="hero_ability_stats">
                <button className="view_all_btn_top">
                  <NavLink to="/heroes">
                    <img
                      className="view-all-active"
                      src={viewAllBtnActive}
                      alt=""
                      srcset=""
                    />
                    <img
                      className="view-all-normal"
                      src={viewAllBtn}
                      alt=""
                      srcset=""
                    />
                  </NavLink>
                </button>
                <p className="hero_type">{heroDetails?.heroNickname}</p>
                <p className="hero_name">{heroDetails?.heroEnum}</p>
                <span className={`hero_desc ${descExpanded ? "expanded" : ""}`}>
                  {heroDetails?.heroLore}
                </span>

                <button
                  className="expand_button"
                  onClick={() => setDescExpanded(!descExpanded)}
                >{`Read ${descExpanded ? "less" : "full"} history`}</button>

                <div className="hero_complexity">
                  <img src={heroAttributeBar} alt="" />
                  <div className="hero_complexity_stat">
                    <img src={heroAttributeBg} alt="" srcset="" />
                    <p>primary attribute</p>
                    <span>{heroDetails?.primaryAttribute}</span>
                  </div>
                  <img src={heroAttributeBar} alt="" />
                  <div className="hero_complexity_stat">
                    <img src={heroAttributeBg} alt="" srcset="" />
                    <p>role</p>
                    <span>{heroDetails?.primaryRole}</span>
                  </div>
                  <img src={heroAttributeBar} alt="" />
                  <div className="hero_complexity_stat">
                    <img src={heroAttributeBg} alt="" srcset="" />
                    <p>elements</p>
                    <span>{heroDetails.primaryElements[0]}</span>
                  </div>
                  <img src={heroAttributeBar} alt="" />
                </div>
                <div className="hero_stats">
                  <div className="hero_stats_avatar">
                    <img
                      className="hero_stats_avatar_image"
                      src={heroDetails?.heroCirclePortrait}
                      alt=""
                    />
                    {/* <img
                      className="hero_stats_avatar_frame"
                      src={heroAvatarFrame2}
                      alt=""
                      srcset=""
                    /> */}
                  </div>
                  {/* <div className="hero_stats_icons">
                    <div className="hero_stats_icon">
                      <img src={statIcon1} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>health</p>
                        <span>734</span>
                      </div>
                    </div>
                    <div className="hero_stats_icon">
                      <img src={statIcon2} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>mana</p>
                        <span>154</span>
                      </div>
                    </div>
                    <div className="hero_stats_icon">
                      <img src={statIcon3} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>damage</p>
                        <span>234</span>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="hero_stats_icons">
                    <div className="hero_stats_icon">
                      <img src={statIcon4} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>attack</p>
                        <span>378</span>
                      </div>
                    </div>
                    <div className="hero_stats_icon">
                      <img src={statIcon5} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>defense</p>
                        <span>450</span>
                      </div>
                    </div>
                    <div className="hero_stats_icon">
                      <img src={statIcon6} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>mobility</p>
                        <span>1150</span>
                      </div>
                    </div>
                  </div> */}
                  <div className="hero_stats_icons column">
                    <div className="hero_stats_icon">
                      <img src={strength} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>strength</p>
                        <span>
                          {heroDetails?.strength || 0}
                          <span className="hero_stat_icon_sub_info">{`+${heroDetails?.perLevelStrength}`}</span>
                        </span>
                      </div>
                    </div>
                    <div className="hero_stats_icon">
                      <img src={agility} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>agility</p>
                        <span>
                          {heroDetails?.agility || 0}
                          <span className="hero_stat_icon_sub_info">{`+${heroDetails?.perLevelAgility}`}</span>
                        </span>
                      </div>
                    </div>
                    <div className="hero_stats_icon">
                      <img src={intelligence} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>intelligence</p>
                        <span>
                          {heroDetails?.intelligence || 0}
                          <span className="hero_stat_icon_sub_info">{`+${heroDetails?.perLevelIntelligence}`}</span>
                        </span>
                      </div>
                    </div>
                    <div className="hero_stats_icon">
                      <img src={spirit} alt="" srcset="" />
                      <div className="hero_stats_icon_info">
                        <p>spirit</p>
                        <span>
                          {heroDetails?.spirit || 0}
                          <span className="hero_stat_icon_sub_info">{`+${heroDetails?.perLevelSpirit}`}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="hero_stats_bars">
                    <div className="bar_wrapper">
                      <p>Carry</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "70%" }} className="bar_filled" />
                      </div>
                    </div>
                    <div className="bar_wrapper">
                      <p>Disabler</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "30%" }} className="bar_filled" />
                      </div>
                    </div>
                    <div className="bar_wrapper">
                      <p>Escape</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "50%" }} className="bar_filled" />
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="hero_stats_bars">
                    <div className="bar_wrapper">
                      <p>support</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "20%" }} className="bar_filled" />
                      </div>
                    </div>
                    <div className="bar_wrapper">
                      <p>jungler</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "49%" }} className="bar_filled" />
                      </div>
                    </div>
                    <div className="bar_wrapper">
                      <p>pusher</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "30%" }} className="bar_filled" />
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="hero_stats_bars">
                    <div className="bar_wrapper">
                      <p>nuker</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "55%" }} className="bar_filled" />
                      </div>
                    </div>
                    <div className="bar_wrapper">
                      <p>durable</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "65%" }} className="bar_filled" />
                      </div>
                    </div>
                    <div className="bar_wrapper">
                      <p>Intiator</p>
                      <div className="bar">
                        <img src={barBg} alt="" srcset="" />
                        <div style={{ width: "100%" }} className="bar_filled" />
                      </div>
                    </div>
                  </div> */}
                  <img
                    className="hero_stats_bg"
                    src={heroStatBg}
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
              {/* <div className="hero_ability_left">
                <h1 className="hero_ability_left_name gradient_heading">
                  {heroDetails?.heroEnum}
                </h1>
                <p className="hero_ability_left_ability">
                  Quam risus volutpat semper risus ullamcorper vitae est ipsum.
                </p>
                <p className="hero_ability_left_desc">
                  Lorem ipsum dolor sit amet consectetur. Quam risus volutpat
                  semper risus ullamcorper vitae est ipsum. Morbi sagittis
                  sagittis facilisis elementum sapien senectus netus sed sed.
                </p>
                <div className="hero_ability_left_abilities_details">
                  <div className="hero_ability_left_abilities_details_field">
                    <img src={strengthIcon} alt="" />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <p>Strength</p>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        {`${heroDetails?.strength}`}
                        <span
                          style={{
                            color: "#2db469",
                            fontSize: "1.8rem",
                            transform: "skew(0deg)",
                          }}
                        >{`+${heroDetails?.perLevelStrength}`}</span>
                      </span>
                    </div>
                  </div>
                  <div className="hero_ability_left_abilities_details_field">
                    <img src={agilityIcon} alt="" />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <p>Agility</p>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        {`${heroDetails?.agility}`}
                        <span
                          style={{
                            color: "#2db469",
                            fontSize: "1.8rem",
                            transform: "skew(0deg)",
                          }}
                        >{`+${heroDetails?.perLevelAgility}`}</span>
                      </span>
                    </div>
                  </div>
                  <div className="hero_ability_left_abilities_details_field">
                    <img src={intelligenceIcon} alt="" />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <p>Intelligence</p>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        {`${heroDetails?.intelligence}`}
                        <span
                          style={{
                            color: "#2db469",
                            fontSize: "1.8rem",
                            transform: "skew(0deg)",
                          }}
                        >{`+${heroDetails?.perLevelIntelligence}`}</span>
                      </span>
                    </div>
                  </div>

                  <div className="hero_ability_left_abilities_details_field">
                    <img src={spiritIcon} alt="" />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <p>Spirit</p>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        {`${heroDetails?.spirit}`}
                        <span
                          style={{
                            color: "#2db469",
                            fontSize: "1.8rem",
                            transform: "skew(0deg)",
                          }}
                        >{`+${heroDetails?.perLevelSpirit}`}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className="hero_ability_right">
                <video autoPlay muted loop id="myVideo">
                  <source
                    src={heroDetails?.heroPreviewVideo}
                    type="video/webm"
                  />
                </video>
              </div> */}
            </div>
          </OptimizedDiv>

          <OptimizedDiv
            className="abilities_section"
            highResImageSrc={abilitiesBgHighRes}
            lowResImageSrc={abilitiesBgLowRes}
          >
            <div className="abilities_grid_video_wrapper">
              <div className="abilities_grid_wrapper">
                <div className="abilities_grid">
                  <p className="abilities_grid_heading">Abilities</p>
                  <div className="abilities_grid_container">
                    {heroDetails?.abilityData
                      ?.filter((item) => item?.runeData.length > 0)
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="abilities_grid_item"
                            onMouseEnter={() => {
                              setSelectedAbilityIndex(item?.abilityClassName);
                            }}
                            onClick={() => setVideoVisible(true)}
                          >
                            <div className="abilities_grid_item_details">
                              {/* <div
                                className="abilities_grid_item_details_video"
                                style={{
                                  backgroundImage: `url(${item?.videoPreview})`,
                                }}
                              >
                                <video autoPlay muted loop id="myVideo">
                                  <source src={item?.video} type="video/mp4" />
                                </video>
                              </div> */}

                              <div className="abilities_grid_item_details_details">
                                <img
                                  className="abilities_grid_item_details_bg"
                                  src={videoDetailBg}
                                  alt=""
                                  srcset=""
                                />
                                <p className="abilities_grid_item_details_details_name">
                                  {item.name}
                                </p>
                                <p className="abilities_grid_item_details_details_desc">
                                  {item?.description?.length > 0 &&
                                    parse(formatDescription(item?.description))}
                                </p>
                              </div>
                            </div>
                            <img
                              className={`skill_frame ${
                                selectedAbilityIndex === item?.abilityClassName
                                  ? "active"
                                  : ""
                              }`}
                              src={
                                selectedAbilityIndex === item?.abilityClassName
                                  ? skillBorderActive
                                  : skillBorder
                              }
                              alt=""
                            />
                            <img
                              className="abilities_grid_item_img"
                              src={item.imageUrl}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="abilities_grid">
                  <p className="abilities_grid_heading">Runes</p>
                  <div style={{ display: "flex", gap: "10px" }}>
                    {heroDetails?.abilityData
                      ?.filter((item) => item?.runeData.length > 0)
                      .map((item, index) => {
                        return (
                          <div
                            className="abilities_grid_container_horizontal"
                            key={index}
                          >
                            {item?.runeData?.map((item, index) => {
                              return (
                                <div
                                  className="abilities_grid_item"
                                  key={index}
                                >
                                  <div className="abilities_grid_item_details">
                                    <div className="abilities_grid_item_details_details">
                                      <img
                                        className="abilities_grid_item_details_bg"
                                        src={videoDetailBg}
                                        alt=""
                                        srcset=""
                                      />
                                      <p className="abilities_grid_item_details_details_name">
                                        {item.name}
                                      </p>
                                      <p className="abilities_grid_item_details_details_desc">
                                        {item?.description?.length > 0 &&
                                          parse(
                                            formatDescription(item?.description)
                                          )}
                                      </p>
                                    </div>
                                  </div>
                                  <img
                                    className={`skill_frame`}
                                    src={skillBorder}
                                    alt=""
                                  />
                                  <img
                                    className="abilities_grid_item_img"
                                    src={item.imageUrl}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                  </div>
                </div>
                {heroDetails?.abilityData?.filter(
                  (item) => item?.runeData.length == 0
                ).length > 1 && (
                  <div className="abilities_grid sub_abilities">
                    <p className="abilities_grid_heading">Sub Abilities</p>
                    <div className="abilities_grid_container">
                      {heroDetails?.abilityData
                        ?.filter((item) => item?.runeData.length == 0)
                        .map((item, index) => {
                          return (
                            index > 0 && (
                              <div
                                key={index}
                                className="abilities_grid_item"
                                onMouseEnter={() => {
                                  setSelectedAbilityIndex(
                                    item?.abilityClassName
                                  );
                                }}
                                onClick={() => setVideoVisible(true)}
                              >
                                <div className="abilities_grid_item_details">
                                  {/* <div
                              className="abilities_grid_item_details_video"
                              style={{
                                backgroundImage: `url(${item?.videoPreview})`,
                              }}
                            >
                              <video autoPlay muted loop id="myVideo">
                                <source src={item?.video} type="video/mp4" />
                              </video>
                            </div> */}
                                  <div className="abilities_grid_item_details_details">
                                    <img
                                      className="abilities_grid_item_details_bg"
                                      src={videoDetailBg}
                                      alt=""
                                      srcset=""
                                    />
                                    <p className="abilities_grid_item_details_details_name">
                                      {item.name}
                                    </p>
                                    <p className="abilities_grid_item_details_details_desc">
                                      {item?.description?.length > 0 &&
                                        parse(
                                          formatDescription(item?.description)
                                        )}
                                    </p>
                                  </div>
                                </div>
                                <img
                                  className={`skill_frame ${
                                    selectedAbilityIndex ===
                                    item?.abilityClassName
                                      ? "active"
                                      : ""
                                  }`}
                                  src={
                                    selectedAbilityIndex ===
                                    item?.abilityClassName
                                      ? skillBorderActive
                                      : skillBorder
                                  }
                                  alt=""
                                />
                                <img
                                  className="abilities_grid_item_img"
                                  src={item.imageUrl}
                                />
                              </div>
                            )
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
              <div className="video_container">
                <div
                  className="video_container_video"
                  style={{
                    backgroundImage: `url(${
                      heroDetails?.abilityData.find(
                        (item) => item.abilityClassName === selectedAbilityIndex
                      )?.videoPreview
                    })`,
                    backgroundSize: "cover",
                  }}
                >
                  <video
                    autoPlay
                    muted
                    loop
                    id="myVideo"
                    key={
                      heroDetails?.abilityData.find(
                        (item) => item.abilityClassName === selectedAbilityIndex
                      )?.video
                    }
                  >
                    <source
                      src={
                        heroDetails?.abilityData.find(
                          (item) =>
                            item.abilityClassName === selectedAbilityIndex
                        )?.video
                      }
                      type="video/mp4"
                    />
                  </video>
                </div>
                <div className="video_container_details">
                  <img src={videoDetailBg} alt="" srcset="" />
                  <p>
                    {
                      heroDetails?.abilityData.find(
                        (item) => item.abilityClassName === selectedAbilityIndex
                      )?.name
                    }
                  </p>
                  <span>
                    {heroDetails?.abilityData.find(
                      (item) => item.abilityClassName === selectedAbilityIndex
                    )?.description?.length > 0 &&
                      parse(
                        formatDescription(
                          heroDetails?.abilityData.find(
                            (item) =>
                              item.abilityClassName === selectedAbilityIndex
                          )?.description
                        )
                      )}
                  </span>
                </div>
              </div>
            </div>

            <div className="next_prev_btns">
              <div className="prev_bg">
                <img className="prev_bg_img" src={prevBg} alt="" srcset="" />
                <a href={`/hero/${prevHeroData.heroEnumValue}`}>
                  <button className="prev_hero">
                    <div className="hero_avatar">
                      <img
                        className="hero_avatar_image"
                        src={prevHeroData.imageUrl}
                        alt=""
                        srcset=""
                      />
                      <img
                        className="hero_avatar_frame"
                        src={heroAvatarFrame}
                        alt=""
                        srcset=""
                      />
                    </div>

                    <div className="hero_avatar_info">
                      <span>Previous hero</span>
                      <p>{prevHeroData.heroEnum}</p>
                    </div>
                  </button>
                </a>
              </div>

              <button className="view_all_btn">
                <NavLink to="/heroes">
                  <img
                    className="view-all-active"
                    src={viewAllBtnActive}
                    alt=""
                    srcset=""
                  />
                  <img
                    className="view-all-normal"
                    src={viewAllBtn}
                    alt=""
                    srcset=""
                  />
                </NavLink>
              </button>
              <div className="next_bg">
                <img className="next_bg_img" src={nextBg} alt="" srcset="" />
                <a href={`/hero/${nextHeroData.heroEnumValue}`}>
                  <button className="next_hero">
                    <div className="hero_avatar_info">
                      <span>Next hero</span>
                      <p>{nextHeroData.heroEnum}</p>
                    </div>
                    <div className="hero_avatar">
                      <img
                        className="hero_avatar_image"
                        src={nextHeroData.imageUrl}
                        alt=""
                        srcset=""
                      />
                      <img
                        className="hero_avatar_frame"
                        src={heroAvatarFrame}
                        alt=""
                        srcset=""
                      />
                    </div>
                  </button>
                </a>
              </div>
            </div>
          </OptimizedDiv>
          <Footer />
        </>
      )}
    </>
  );
};

export default Hero;
